var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "man-user 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 10.8116C13.0828 10.8116 14.7714 8.77127 14.7714 6.25443C14.7714 3.73755 14.217 1.69727 11 1.69727C7.78301 1.69727 7.22852 3.73755 7.22852 6.25443C7.22852 8.77127 8.91711 10.8116 11 10.8116Z",
    fill: "#DC7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.63417 18.974C2.63266 18.9229 2.63342 18.7928 2.63417 18.974V18.974Z",
    fill: "#8920CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.3652 19.1152C19.3661 18.7712 19.3676 19.0656 19.3652 19.1152V19.1152Z",
    fill: "#8920CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0947 17.554C18.0251 13.1672 17.4511 11.9172 13.0592 11.126C13.0592 11.126 12.441 11.9124 11 11.9124C9.55901 11.9124 8.94067 11.126 8.94067 11.126C4.59665 11.9086 3.98781 13.14 3.90775 17.4115C3.90119 17.7603 3.89815 17.7786 3.89697 17.7381C3.89724 17.814 3.89756 17.9543 3.89756 18.199C3.89756 18.199 4.94318 20.3031 11 20.3031C17.0567 20.3031 18.1024 18.199 18.1024 18.199C18.1024 18.0418 18.1025 17.9324 18.1027 17.8581C18.1015 17.8831 18.0992 17.8346 18.0947 17.554Z",
    fill: "#DC7BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.6dd2dac2fc6566a046e137b80da823ad.svg";
export { ForwardRef as ReactComponent };